module.exports = __webpack_public_path__ + "img/sysw.ce81963a.png";